import { render, staticRenderFns } from "./dataPreview.vue?vue&type=template&id=24403ad0&scoped=true"
import script from "./dataPreview.vue?vue&type=script&lang=js"
export * from "./dataPreview.vue?vue&type=script&lang=js"
import style0 from "./dataPreview.vue?vue&type=style&index=0&id=24403ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24403ad0",
  null
  
)

export default component.exports